import { isEmpty, isUndefined } from 'lodash';

import { IAdditionalDetailDefinition } from 'types/additional-info';
import { FIELD_VIEW_TYPES } from 'modules/additional-info-common/additional-info.constants';
import { IFieldRenderParams } from 'modules/additional-info-common/fields/fields.types';
import { PLATFORM_TYPES } from '@sitegen/common/constants/platforms';
import { SELECTED_ITEM_KEY } from '../pyc-redeem/pyc-redeem.constants';

const HIDDEN_FIELD_NAMES = ['platform', SELECTED_ITEM_KEY];

export const isDropDown = (fieldDefinition: IAdditionalDetailDefinition): boolean =>
    fieldDefinition?.type === FIELD_VIEW_TYPES.STRING && !isUndefined(fieldDefinition?.rules?.inArray);

export const getFieldComponentType = (fieldDefinition: IAdditionalDetailDefinition): FIELD_VIEW_TYPES =>
    isDropDown(fieldDefinition) ? FIELD_VIEW_TYPES.DROPDOWN : FIELD_VIEW_TYPES[fieldDefinition.type.toUpperCase()];

export const getFieldValue = (fieldDefinition: IAdditionalDetailDefinition): string | string[] | null => {
    if (fieldDefinition.rules.inArray) {
        return fieldDefinition.rules.inArray;
    }

    return null;
};

export const redemptionAdditionalFieldsAdapter = (additionalDetailsDefinition: IAdditionalDetailDefinition[]): IFieldRenderParams[] => {
    // Filter out platforms, because they are rendered on a different screen as buttons, instead of inputs
    return additionalDetailsDefinition
        .filter(field => !HIDDEN_FIELD_NAMES.includes(field.name))
        .map(field => {
            const fieldType = getFieldComponentType(field);
            const fieldValue = getFieldValue(field);
            return {
                name: field.name,
                isRequired: field.isRequired,
                value: fieldValue,
                type: fieldType,
                minNumber: field?.rules?.min,
                maxNumber: field?.rules?.max,
                minStringLength: field?.rules?.minStringLength,
                maxStringLength: field?.rules?.maxStringLength
            };
        });
};

export const redemptionPlatformsAdapter = (additionalDetailsDefinition: IAdditionalDetailDefinition[]): PLATFORM_TYPES[] => {
    const platformsDetails = additionalDetailsDefinition
        .find((detailItem: IAdditionalDetailDefinition) => detailItem.name === 'platform');

    return (platformsDetails?.rules?.inArray ?? [PLATFORM_TYPES.PC]) as PLATFORM_TYPES[];
};

export const redemptionPYCActionsAdapter = (additionalDetailsDefinition: IAdditionalDetailDefinition[]): string[] => {
    const availableActions = additionalDetailsDefinition
        .find((detailItem: IAdditionalDetailDefinition) => detailItem.name === SELECTED_ITEM_KEY);

    return (availableActions?.rules?.inArray ?? []) as string[];
};

export const hasSelectedItem = (additionalDetailsDefinition: IAdditionalDetailDefinition[]): boolean => {
    const availableActions = additionalDetailsDefinition
        .find((detailItem: IAdditionalDetailDefinition) => detailItem.name === SELECTED_ITEM_KEY);
    return !isEmpty(availableActions?.rules?.inArray ?? []);
};
